import React, { useState } from 'react';
import Button from '@mui/material/Button';
import IosShareOutlinedIcon from '@mui/icons-material/IosShareOutlined';
import { useTranslation } from 'react-i18next';
import { Notification } from '@/common/utils/index';
import { exportRegistrationCodesCsv } from '@/entities/admin-access-codes/admin-access-codes.api';

const ExportButton = ({ search, status, resellerId, sortBy, sortOrder }) => {
  const { t } = useTranslation();
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    try {
      setIsExporting(true);
      const blob = await exportRegistrationCodesCsv({
        search,
        status,
        resellerId,
        sortBy,
        sortOrder,
      });
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.setAttribute('download', 'registration-codes.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      Notification.error(t('Downloading registration codes error'));
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Button
      color="success"
      disabled={isExporting}
      loading={isExporting}
      onClick={handleExport}
      startIcon={<IosShareOutlinedIcon />}
      size="medium"
      sx={{
        marginLeft: 'auto',
        minWidth: '132px',
        alignSelf: 'center',
        padding: '8px',
      }}
    >
      {isExporting ? t('Exporting...') : t('Export CSV')}
    </Button>
  );
};

export default ExportButton;
